module.exports = "../study/imgs/maps/Nagano/S8/Climate/Precipitation/Nagano_Precipitation_GFDL_RCP85_End.png";